/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Footer_Link_AboutInputs */

const en_directory_footer_link_about = /** @type {(inputs: Directory_Footer_Link_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`About`)
};

const zh_directory_footer_link_about = /** @type {(inputs: Directory_Footer_Link_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`关于`)
};

/**
* | output |
* | --- |
* | "About" |
*
* @param {Directory_Footer_Link_AboutInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_footer_link_about = /** @type {((inputs?: Directory_Footer_Link_AboutInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Footer_Link_AboutInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_footer_link_about(inputs)
	return zh_directory_footer_link_about(inputs)
});
export { directory_footer_link_about as "directory.footer.link_about" }